import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { Fragment } from 'react'
import {
    FLOATING_PREVIEW,
    MY_WEBCAM,
    QUICK_REPLY,
} from '../../../../constants/floaters'
import { palette } from '../../../styles/colors'
import shape from '../../../styles/shape'
import FloatingPreview from './FloatingPreview'
import QuickReply from './QuickReply'
import UserBroadcaster from './UserBroadcaster'

export const previewRootStyles = css({
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',
    display: 'flex',
    flexFlow: 'column nowrap',
    borderRadius: shape.borderRadius,
    overflow: 'hidden',
})

export const PreviewRoot = styled('div')(previewRootStyles)

export const LargeContainer = styled('div')({
    background: palette.background,
    width: '100%',
    borderTopRightRadius: shape.borderRadius,
    borderTopLeftRadius: shape.borderRadius,
})

export const smallStyles = css({
    borderRadius: shape.borderRadius,
    '& img,video': {
        borderRadius: shape.borderRadius,
    },
})

export const innerStyles = css({
    cursor: 'pointer',
    width: '100%',
    background: palette.backgroundRaised,
    borderBottomRightRadius: shape.borderRadius,
    borderBottomLeftRadius: shape.borderRadius,
    '& img,video': {
        borderBottomRightRadius: shape.borderRadius,
        borderBottomLeftRadius: shape.borderRadius,
    },
})

export default {
    [QUICK_REPLY]: QuickReply,
    [FLOATING_PREVIEW]: FloatingPreview,
    // [FLOATING_ROOM]: FloatingRoom,
    [MY_WEBCAM]: UserBroadcaster,
    NOOP: Fragment,
}
